'use client';

import { twMerge } from 'tailwind-merge';

interface LoadingSpinnerProps {
  loadingText?: string;
  isMini?: boolean;
  className?: string;
  innerClassName?: string;
  borderClassName?: string;
}

const RING_COUNT = 4;
const ANIMATION_DELAY_STEP = -0.15;

export const LoadingSpinner = ({
  loadingText = '',
  isMini = false,
  className = '',
  innerClassName = '',
  borderClassName = '',
}: LoadingSpinnerProps) => (
  <div
    className={twMerge(
      'flex flex-col items-center justify-between',
      isMini ? '' : 'm-16',
      className,
    )}
    data-testid="LoadingSpinner"
  >
    <div className={twMerge(isMini ? '' : 'p-6', innerClassName)}>
      <div
        className={twMerge(
          'relative inline-block',
          isMini ? 'h-[18px] w-[18px]' : 'h-[80px] w-[80px]',
        )}
      >
        {Array.from({ length: RING_COUNT }).map((_, idx) => (
          <div
            key={idx}
            className={twMerge(
              'border-t-bg-trench ring-spin absolute box-border block rounded-full border-solid border-r-transparent border-b-transparent border-l-transparent',
              isMini
                ? 'm-[2px] h-[18px] w-[18px] border-[2px]'
                : 'm-[8px] h-[64px] w-[64px] border-[8px]',
              borderClassName,
            )}
            style={{ animationDelay: `${ANIMATION_DELAY_STEP * (RING_COUNT - idx)}s` }}
          />
        ))}
      </div>
    </div>

    {loadingText && <span className="text-trench w-52 text-center text-lg">{loadingText}</span>}
  </div>
);
